import '@elem/compBlog/blog.scss';
import sanitizeHtml from 'sanitize-html';
import News from '@elem/compPage/News';
import css from './index.module.scss';

import NewsNav from '@/components/NewsNav';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import Image from '@/components/UI/Image';
import Pagination from '@/components/UI/Pagination';
import SearchInput from '@/components/UI/SearchInput';
import seoconfig from '@/seoconfig/news';
import { subscribe } from '@/service';
import { isReadyLang, redirectTo404 } from '@/utils';
import { getPrivacyPolicy } from '@/utils/common';
import { useGlobal } from '@/utils/useGlobal';

const NEWS_LOCALES = ['us', 'ca'];
function OriginalNews({ postsData, categoriesData, lang, SEO }: any) {
    const PAGE_SIZE = Number(process.env.NEXT_PUBLIC_PAGE_SIZE_NEWSROOM);
    const { Link, useState, useEffect, useLang, useRouter, gtm, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const IS_BLOG_UI_SITES = ['us'].includes(locale);
    //let postsInit: any = [];
    const [postsInit, setPostsInit] = useState([]);
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    const [check, setCheck] = useState(false);

    // if (Array.isArray(postsData)) {
    //     postsInit = postsData?.map((item: any) => {
    //         const images = item.yoast_head_json?.og_image || [
    //             {
    //                 url: '/img/blank-image.png',
    //                 width: '360',
    //                 height: '260',
    //             },
    //         ];
    //         return {
    //             id: item.id,
    //             slug: item.slug,
    //             link: item.guid.rendered,
    //             date: item.date,
    //             title: item.title.rendered,
    //             content: item.content.rendered,
    //             images: item.jetpack_featured_media_url || images[0].url,
    //             width: images[0].width,
    //             height: images[0].height,
    //             categories: item.categories,
    //         };
    //     });
    // }
    const [firstData, setFirstData] = useState({});
    //const firstData = postsInit[0] || {};

    const [currPage, setCurrPage] = useState(1);
    const [currPageNews, setCurrPageNews] = useState([]);

    const getCurrPageNews = (news: any, page: number) => [...news]?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    const onPageChange = (page: number, postsInit1?: any[]) => {
        const postsInit2 = postsInit1 || postsInit || [];
        const currPageNews = getCurrPageNews(postsInit2, page);
        setCurrPageNews(currPageNews);
        setCurrPage(page);
    };

    //const categoryMap = {} as any;
    const [categoryMap, setCategoryMap] = useState({});

    if (Array.isArray(categoriesData)) {
        categoriesData?.map((item: any) => {
            categoryMap[item.id] = item.name;
        });
    }

    const getCategoryName = (data: any) => {
        if (!data) return '';
        const detailCategory = [...data.categories]?.pop();
        return categoryMap[String(detailCategory)]?.toUpperCase();
    };

    const getDataLayer = (params: any, type: string) => {
        return {
            event: 'uaEvent',
            event_name: 'select_news',
            title_name: sanitizeHtml(params?.title, {
                allowedTags: [''],
            }),
            button_name: type,
        };
    };

    // Subscribe
    const [inputMsg, setInputMsg] = useState('');
    const [email, setEmail] = useState('');

    const validEmail = (_email: string) => {
        if (!/(.+)@(.+){2,}\.(.+){2,}/.test(_email)) {
            setInputMsg(t('bottom_subscription.site_bottom_subscription_tip_two'));
            return;
        }
        setInputMsg('');
        return true;
    };

    const joinInputChange = (e: any) => {
        const val = e.target.value;
        setEmail(val);
        validEmail(val);
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && inputMsg) {
            setInputMsg('');
        }
        if (check && !inputMsg) {
            setInputMsg(t('check'));
        }
    };

    const subscribeJoin = async () => {
        if (!validEmail(email)) return;
        if (EU_SITES.includes(locale) && !check) return setInputMsg(t('signup_popup.main.check'));

        const subscribeRes = await subscribe(email, locale, 'WEB_NEWS', {
            sector_name: `Newsroom_${t('news.newsroom.join_us')}`,
            entry_position: 2,
        });

        gtm.push({
            event: 'uaEvent',
            event_name: 'email_submit',
            button_name: 'submit',
            status: subscribeRes?.code === '0' ? 'Success' : 'Fail',
        });
        setInputMsg(
            subscribeRes?.code === '0'
                ? t('bottom_subscription.site_bottom_subscription_tip_three')
                : subscribeRes?.code === '1000'
                ? t('bottom_subscription.site_bottom_subscription_tip_five')
                : subscribeRes?.message || t('bottom_subscription.site_bottom_subscription_tip_four'),
        );
        setEmail('');
    };

    useEffect(() => {
        const initHandle_data = async () => {
            const originA = location.origin || 'https://www.ecoflow.com';
            const resA: any = await fetch(`${originA}/api/getblognews`, {
                method: 'get',
            });
            const dataA = await resA.json();
            const dataB = dataA?.data || {};
            return {
                postsData: dataB.postsData || [],
                categoriesData: dataB.categoriesData || [],
            };
        };
        const initHandle_page = async (postsData: any, categoriesData: any) => {
            let postsInitA: any = [];
            if (Array.isArray(postsData)) {
                postsInitA = postsData?.map((item: any) => {
                    const images = item.yoast_head_json?.og_image || [
                        {
                            url: '/img/blank-image.png',
                            width: '360',
                            height: '260',
                        },
                    ];
                    return {
                        id: item.id,
                        slug: item.slug,
                        link: item.guid.rendered,
                        date: item.date,
                        title: item.title.rendered,
                        content: item.content.rendered,
                        images: item.jetpack_featured_media_url || images[0].url,
                        width: images[0].width,
                        height: images[0].height,
                        categories: item.categories,
                    };
                });
            }
            const categoryMapA = {} as any;
            //const firstData = postsInitA[0] || {};
            setFirstData(postsInitA[0] || {});
            onPageChange(1, postsInitA);
            if (Array.isArray(categoriesData)) {
                categoriesData?.map((item: any) => {
                    categoryMapA[item.id] = item.name;
                });
            }
            setCategoryMap(categoryMapA);
        };
        const initHandle_all = async () => {
            const dataA = await initHandle_data();
            // const dataA = {
            //     postsData,
            //     categoriesData,
            // };
            initHandle_page(dataA.postsData, dataA.categoriesData);
        };
        initHandle_all();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currPage]);

    useEffect(() => {
        //onPageChange(1);
    }, []);

    return (
        <PageLayout className={css.newsWrap}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || lang.description} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />

            {!NEWS_LOCALES?.includes(locale) && <NewsNav className="wbg" title={t('news.newsroom.title_nav')} category="newsroom" />}
            <div className="container">
                {!NEWS_LOCALES?.includes(locale) && (
                    <>
                        <div className="product">
                            {firstData?.link && (
                                <Link
                                    href={`/news/${firstData.id}/${firstData.slug}`}
                                    ariaLabel={firstData.title}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_banner',
                                        banner_name: firstData.title,
                                        position: 'news_1',
                                        button_name: 'Image',
                                    }}
                                >
                                    <div className="left">
                                        {firstData?.images && <Image src={firstData.images} layout="fill" className="fullImgs" alt={firstData.title} />}
                                        {/* UI要求添加一层蒙版 */}
                                        <div className="mask"></div>
                                        <div className="tits">
                                            <h1 className="font-family-bold">{firstData.title}</h1>
                                            <div
                                                className="content font-family-regular"
                                                dangerouslySetInnerHTML={{
                                                    __html: sanitizeHtml(firstData.content, {
                                                        allowedTags: [''],
                                                    }),
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                </Link>
                            )}
                        </div>
                        <div className="newsList">
                            <div className="left">
                                <div className="items-box">
                                    <ul>
                                        {currPageNews?.map((item: any) => (
                                            <li className="items" key={item.id + Math.random()}>
                                                <div className="item-l">
                                                    {item.images && (
                                                        <Link
                                                            href={`/news/${item.id}/${item.slug}`}
                                                            ariaLabel={getCategoryName(item)}
                                                            dataLayer={getDataLayer(item, 'Image')}
                                                        >
                                                            <Image
                                                                src={item.images}
                                                                width={item.width}
                                                                height={item.height}
                                                                className="fullImgs"
                                                                alt={getCategoryName(item)}
                                                            />{' '}
                                                        </Link>
                                                    )}
                                                </div>
                                                <div className="item-r">
                                                    <div className="title">
                                                        <span
                                                            className="label font-family-regular"
                                                            style={{
                                                                borderColor: getCategoryName(item) ? '#dea904' : '#fff',
                                                            }}
                                                        >
                                                            {getCategoryName(item)}
                                                        </span>
                                                    </div>
                                                    <h4>
                                                        <Link
                                                            href={`/news/${item.id}/${item.slug}`}
                                                            ariaLabel={getCategoryName(item)}
                                                            dataLayer={getDataLayer(item, 'Title')}
                                                        >
                                                            <p
                                                                className="textEllipsis line2"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: sanitizeHtml(item?.title, {
                                                                        allowedTags: [''],
                                                                    }),
                                                                }}
                                                            ></p>
                                                        </Link>
                                                    </h4>
                                                    <p
                                                        className="content textEllipsis line3"
                                                        dangerouslySetInnerHTML={{
                                                            __html: sanitizeHtml(item?.content, {
                                                                allowedTags: [''],
                                                            }),
                                                        }}
                                                    ></p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <Pagination
                                    defaultCurrent={currPage}
                                    total={postsInit?.length}
                                    pageSize={PAGE_SIZE}
                                    onChange={onPageChange}
                                    className="default-page"
                                />
                            </div>
                        </div>
                    </>
                )}
                {!!NEWS_LOCALES.includes(locale) && <News />}
                {!IS_BLOG_UI_SITES && (
                    <div className="productb">
                        <div className="left">
                            <Image
                                src="https://websiteoss.ecoflow.com/upload/image/1757412523895/joinus.jpg"
                                layout="fill"
                                className="fullImgs"
                                alt={t('news.newsroom.join_us')}
                            />
                        </div>
                        <div className="right">
                            <h2>{t('news.newsroom.join_us')}</h2>
                            <div className="content">{t('news.newsroom.latest_news')}</div>
                            <div className={`search ${isMobile ? 'mobile-search' : ''}`}>
                                <SearchInput
                                    id="emailInputJoin"
                                    value={email}
                                    placeholder={t('news.newsroom.email')}
                                    className="default-input"
                                    enterButton={t('news.newsroom.join_now')}
                                    onChange={joinInputChange}
                                    onSearch={subscribeJoin}
                                />
                                <div className="input-msg">{inputMsg}</div>
                            </div>
                            {EU_SITES.includes(locale) && (
                                <div className="agreement">
                                    <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                                    <label htmlFor="agree" className="agree-label">
                                        {t.rich('news.newsroom.agreement', {
                                            privacy: (text: string) => (
                                                <Link className="link" href={getPrivacyPolicy(locale)}>
                                                    {text}
                                                </Link>
                                            ),
                                            terms: (text: string) => (
                                                <Link className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`}>
                                                    {text}
                                                </Link>
                                            ),
                                        })}
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </PageLayout>
    );
}

export default function NewsIndex({ postsData, categoriesData, lang, SEO, tempData }: any) {
    return <OriginalNews postsData={postsData} categoriesData={categoriesData} lang={lang} SEO={SEO} />;
}

const newsroomObj: any = {
    en: 'categories&slug=newsroom',
    it: 'categories&slug=news-room',
};

const NEXT_PUBLIC_MODY = process.env.NEXT_PUBLIC_MODY;
const IS_LOCAL_TEST = NEXT_PUBLIC_MODY === 'test' || NEXT_PUBLIC_MODY === 'uat';
export async function getStaticProps({ locale }: any) {
    if (!isReadyLang(locale) || ['sa', 'cis', 'eu'].includes(locale)) {
        return redirectTo404();
    }

    // For US/CA site, use blog logic
    /**
     * @param Description For US site, also apply the blog Design with its' own data(news' data)
     * @param Author Kalkin
     * @param Release 2026/01/20
     * @param PM Alisha Chen
     * @param Referrence https://ecoflow.feishu.cn/wiki/BK2ywJHOdiZYi6kFA6ccZVuInCc
     * @param Date 2026/01/09
     */
    if (!!NEWS_LOCALES.includes(locale)) {
        return {
            props: {
                postsData: [],
                categoriesData: [],
                tempData: {},
                id: '',
            },
            revalidate: 12000, //20分钟缓存一次
        };
    }

    // For other sites, use original logic
    const categoriesData: any[] = [];
    const postsData: any[] = [];
    const newsroomCategories = [];
    const newsroomUrl = newsroomObj[locale] || newsroomObj['en'];
    if (!IS_LOCAL_TEST) {
        // try {
        //     categoriesData = await fetchWP2('categories', locale);
        //     const newsroom = await fetchWP2(newsroomUrl, locale);
        //     const newsroomId = newsroom[0]?.id;
        //     if (newsroomId) {
        //         newsroomCategories = categoriesData?.filter((item: any) => item.parent === newsroomId)?.map((item: any) => item.id);
        //         newsroomCategories.push(newsroomId);
        //     }
        //     postsData = await fetchWP2(`posts&per_page=100&categories=${newsroomCategories.join(',')}`, locale);
        // } catch (e) {}
    }

    return {
        props: {
            postsData: postsData || [],
            categoriesData: categoriesData || [],
        },
        revalidate: 12000, //20分钟缓存一次
    };
}
